 /* globals urls, RSVP, ReplacePaymentMethodPopup */
(function($) {

	// Initiate Popups
	// http://dimsemenov.com/plugins/magnific-popup/documentation.html
	function initPopups(event, strContainSelector){
		// Use the provided container selector if provided, otherwise assume this is specified as the initial page load
		var strPopupSelector = (strContainSelector ? strContainSelector+' ' : '') + '.magnific-popup';
		$(strPopupSelector).magnificPopup({
			type: 'ajax',
			ajax: {
				settings: {
					method: "POST",
					url: urls.ajax
				}
			},
			mainClass: 'mfp-with-zoom',
			showCloseBtn: false,
			zoom: {
				enabled: true,
				duration: 300,
				easing: 'ease-in-out',
			},
			callbacks: {
				elementParse: function(item) {
					var popupType = item.el.data('popuptype');
					console.log(popupType);
					var popupData = item.el.data();
					delete popupData.magnificPopup;
					delete popupData.popuptype;
					var postData = {
						action: 'render_popup',
						popupType: popupType,
						popupData: popupData
					};
					var mp = $.magnificPopup.instance;
					mp.st.ajax.settings.data = postData;
					mp.popupType = popupType;
					mp.popupData = popupData;
				},
				ajaxContentAdded: function() {
					// Init popup actions
					initPopupEvents(this.popupType);
					$.maskFields();
				}
			}
		});
	}


	function initPopupEvents(strPopupType){
		switch(strPopupType){
			case 'cancel-registration':
				$('#kois-popup-contain #cancel-registration-button').click(cancelRegistration);
				break;
			case 'cancel-symp-add-on':
				$('#kois-popup-contain #cancel-symp-add-on-button').click(cancelSymposiumAddOn);
				break;
			case 'cancel-waitlist':
				$('#kois-popup-contain #remove-from-waitlist-button').click(removeFromWaitlist);
				break;
			case 'add-printed-manual':
				$('#kois-popup-contain .purchase-printed-manual-add-on').click(addPrintedManual);
				break;
			case 'one-time-payment':
				$('#kois-popup-contain #one-time-payment-button').click(addOneTimePaymentToCart);
				break;
			case 'change-payment-method':
				$('#kois-popup-contain #change-payment-method-button').click(changePaymentMethod);
				$('#kois-popup-contain input[name="SelectedCard"]').change(function(){
					if( $(this).val() === 'new' ){
						$('#kois-popup-contain .new-card--details').removeClass( 'hidden' );
					}
					else{
						$('#kois-popup-contain .new-card--details').addClass( 'hidden' );
					}
				});
				break;
			case 'replace-payment-method':
					var mp = $.magnificPopup.instance;
					var cardToReplace = mp.popupData.curcard || null;
					var fullName = mp.popupData.fullname || '';
					var popup = new ReplacePaymentMethodPopup('replace-payment-method', cardToReplace, fullName);
					break;
			case 'symposium-addon-waitlist':
				$('#kois-popup-contain #symposium-addon-waitlist-button').click(joinSymposiumAddonWaitlist);
				$('#kois-popup-contain .kois-quantity-spinner')
					// Doing this to turn off the plugin's "click and hold" functionality which can bug out in certain cases
					.on('mousedown', '[data-spin="up"], [data-spin="down"]', function(e){
						// If the event is a mousedown, kill it so no other events can take place
						e.stopImmediatePropagation();
					})
					.spinner();
				break;
			case 'cancel-symposium-addon-waitlist':
				$('#kois-popup-contain #cancel-symposium-addon-waitlist-button').click(cancelSymposiumAddonWaitlist);
				break;
			default:
				break;
		}

		$('.popup-cancel-btn').on('click', function(e){
			e.preventDefault();
			$.magnificPopup.instance.close();
		});
	}

	function cancelRegistration(event){
		event.preventDefault();

		// Disable the cancel button
		$('#kois-popup-contain #cancel-registration-button').prop( 'disabled', true );
		$('#kois-popup-contain #cancel-registration-button .loader').css('opacity', '1');

		// Clear out any previous popup error messages
		$('#kois-popup-contain #popup-messages-target').html('');

		var mp = $.magnificPopup.instance;
		var enrollmentId = mp.popupData.enrollmentid || null;
		var seatId = mp.popupData.seatid || null;
		
		var enrollmentCancelData = [
			{
				enrollmentId: enrollmentId,
				seatId: seatId
			}
		];
		
		// Optional related enrollment to cancel at the same time
		var relatedEnrollmentId = mp.popupData.relatedenrollmentid || null;
		var relatedSeatId = mp.popupData.relatedseatid || null;
		if( relatedEnrollmentId ){
			enrollmentCancelData.push({
				enrollmentId: relatedEnrollmentId,
				seatId: relatedSeatId
			});
		}

		$.ajax({
			method: 'POST',
			url: urls.ajax,
			data: {
				action: 'cancel_user_enrollment',
				enrollments: enrollmentCancelData,
			}
		}).done(function( strResponseJson ){
			var objUnenrollStatus = $.parseJSON( strResponseJson );

			if( objUnenrollStatus.success !== true ){
				$('#kois-popup-contain #popup-messages-target').html( objUnenrollStatus.message );
				// Enable the cancel button again
				$('#kois-popup-contain #cancel-registration-button').prop( 'disabled', false );
				$('#kois-popup-contain #cancel-registration-button .loader').css('opacity', '0');
			}
			else{
				window.location = window.location.pathname;
			}
		});
	}
	
	function cancelSymposiumAddOn(event){
		event.preventDefault();

		// Disable the cancel button
		$('#kois-popup-contain #cancel-symp-add-on-button').prop( 'disabled', true );
		$('#kois-popup-contain #cancel-symp-add-on-button .loader').css('opacity', '1');

		// Clear out any previous popup error messages
		$('#kois-popup-contain #popup-messages-target').html('');

		var mp = $.magnificPopup.instance;
		var addOnId = mp.popupData.addonid || null;

		$.ajax({
			method: 'POST',
			url: urls.ajax,
			data: {
				action: 'cancel_symp_add_on',
				addOnId: addOnId,
			}
		}).done(function( objCancelStatus ){
			if( objCancelStatus.success !== true ){
				$('#kois-popup-contain #popup-messages-target').html( objCancelStatus.message );
				// Enable the cancel button again
				$('#kois-popup-contain #cancel-symp-add-on-button').prop( 'disabled', false );
				$('#kois-popup-contain #cancel-symp-add-on-button .loader').css('opacity', '0');
			}
			else{
				window.location = window.location.pathname;
			}
		});
	}

	function removeFromWaitlist(event){
		event.preventDefault();

		// Disable the cancel button
		$('#kois-popup-contain #remove-from-waitlist-button').prop( 'disabled', true );
		$('#kois-popup-contain #remove-from-waitlist-button .loader').css('opacity', '1');

		// Clear out any previous popup error messages
		$('#kois-popup-contain #popup-messages-target').html('');

		var mp = $.magnificPopup.instance;
		var waitlistId = mp.popupData.waitlistid || null;

		$.ajax({
			method: 'POST',
			url: urls.ajax,
			data: {
				action: 'remove_user_from_waitlist',
				waitlistId: waitlistId
			}
		}).done(function( strResponseJson ){
			var objWaitlistStatus = $.parseJSON( strResponseJson );

			if( objWaitlistStatus.success !== true ){
				$('#kois-popup-contain #popup-messages-target').html( objWaitlistStatus.message );
				// Enable the cancel button again
				$('#kois-popup-contain #remove-from-waitlist-button').prop( 'disabled', false );
				$('#kois-popup-contain #remove-from-waitlist-button .loader').css('opacity', '0');
			}
			else{
				window.location = window.location.pathname + '?wlRemove=1';
			}
		});
	}
	
	function addPrintedManual(event){
		event.preventDefault();

		// Disable the purchase button
		$('#kois-popup-contain .purchase-printed-manual-add-on').prop( 'disabled', true );
		$('#kois-popup-contain .purchase-printed-manual-add-on .loader').css('opacity', '1');

		// Clear out any previous popup error messages
		$('#kois-popup-contain #popup-messages-target').html('');

		var mp = $.magnificPopup.instance;
		var jwt = mp.popupData.jwt || null;
		
		// Make AJAX call to add a printed manual cart item to the user's WC cart
		$.ajax({
			method: 'POST',
			url: urls.ajax,
			data: {
				action: 'add_printed_manual_cart_item',
				jwt: jwt
			}
		})
		.done(function( response ) {
			if(response.success){
				// redirect to the returned URL
				window.location = response.redirect_url;
			}
			else{
				var message = (response.message ? response.message : 'An error occurred while attempting to add the printed manual to your cart.');
				$('#kois-popup-contain #popup-messages-target').html( message );
				// Enable the add button again
				$('#kois-popup-contain .purchase-printed-manual-add-on').prop( 'disabled', false );
				$('#kois-popup-contain .purchase-printed-manual-add-on .loader').css('opacity', '0');
			}
		});
	}

	function addOneTimePaymentToCart(event){
		event.preventDefault();

		// Disable the button
		$('#kois-popup-contain #one-time-payment-button').prop( 'disabled', true ).addClass( 'loading' );

		// Clear out any previous popup error messages
		$('#kois-popup-contain #popup-messages-target').html('');

		var mp = $.magnificPopup.instance;
		var enrollmentId = mp.popupData.enrollmentid || null;
		var templateId = mp.popupData.templateid || null;
		var instanceId = mp.popupData.instanceid || null;
		var max = mp.popupData.remaining || 0.00;
		var due = mp.popupData.due || 0.00;
		var title = mp.popupData.title || null;
		var date = mp.popupData.date || null;
		var category = mp.popupData.category || null;
		var amount = $('#kois-popup-contain #payment-amount').val();
		var currentCartItem = mp.popupData.cartitemid || null;
		
		// Make AJAX call to add a one-time payment cart item to the user's WC cart
		$.ajax({
			method: 'POST',
			url: urls.ajax,
			data: {
				action: 'add_one_time_payment_cart_item',
				enrollmentId: enrollmentId,
				templateId: templateId,
				instanceId: instanceId,
				max: max,
				due: due,
				title: title,
				date: date,
				category: category,
				amount: amount,
				currentCartItem: currentCartItem
			}
		})
		.done(function( response ) {
			if(response.success){
				// redirect to the returned URL
				window.location = response.redirect_url;
			}
			else{
				var message = (response.message ? response.message : 'An error occurred while attempting to add the one-time payment to your cart.');
				$('#kois-popup-contain #popup-messages-target').html( message );
				// Enable the add button again
				$('#kois-popup-contain #one-time-payment-button').prop( 'disabled', false ).removeClass( 'loading' );
			}
		});
	}

	function joinSymposiumAddonWaitlist(event){
		event.preventDefault();

		// Disable the button
		$('#kois-popup-contain #symposium-addon-waitlist-button').prop( 'disabled', true ).addClass( 'loading' );
		// Clear out any previous popup error messages
		$('#kois-popup-contain #popup-messages-target').html('');

		var mp = $.magnificPopup.instance;
		var addOnType = mp.popupData.type || null;
		var requestMode = mp.popupData.mode || 'Join';
		var numberToWaitlist = $('#kois-popup-contain #number-to-waitlist').val();

		// Make AJAX call to add or update an Add-On waitlist record
		$.ajax({
			method: 'POST',
			url: urls.ajax,
			data: {
				action: 'join_symposium_addon_waitlist',
				addOnType: addOnType,
				requestMode: requestMode,
				numberToWaitlist: numberToWaitlist
			}
		})
		.done(function( response ) {
			if(response.success){
				// redirect to the returned URL
				window.location = response.redirect_url;
			}
			else{
				var message = (response.message ? response.message : 'An error occurred while attempting to join the waitlist.');
				$('#kois-popup-contain #popup-messages-target').html( message );
				// Enable the add button again
				$('#kois-popup-contain #symposium-addon-waitlist-button').prop( 'disabled', false ).removeClass( 'loading' );
			}
		});
	}

	function cancelSymposiumAddonWaitlist(event){
		event.preventDefault();

		// Disable the button
		$('#kois-popup-contain #cancel-symposium-addon-waitlist-button').prop( 'disabled', true ).addClass( 'loading' );
		// Clear out any previous popup error messages
		$('#kois-popup-contain #popup-messages-target').html('');

		var mp = $.magnificPopup.instance;
		var addOnType = mp.popupData.type || null;

		// Make AJAX call to remove a user from an Add-On waitlist
		$.ajax({
			method: 'POST',
			url: urls.ajax,
			data: {
				action: 'cancel_symposium_addon_waitlist',
				addOnType: addOnType
			}
		})
		.done(function( response ) {
			if(response.success){
				// redirect to the returned URL
				window.location = response.redirect_url;
			}
			else{
				var message = (response.message ? response.message : 'An error occurred while attempting to remove you from the waitlist.');
				$('#kois-popup-contain #popup-messages-target').html( message );
				// Enable the add button again
				$('#kois-popup-contain #cancel-symposium-addon-waitlist-button').prop( 'disabled', false ).removeClass( 'loading' );
			}
		});
	}

	function changePaymentMethod(event){
		event.preventDefault();

		// Disable the button
		$('#kois-popup-contain #change-payment-method-button').prop( 'disabled', true ).addClass( 'loading' );
		// Clear out any previous popup error messages
		$('#kois-popup-contain #popup-messages-target').html('');

		// Update card handler closure
		function handleUpdateCard(enrollmentList, cardId, card){
			updatePlanCard(enrollmentList, cardId, card).then(function(updated){
				// Refresh page
				window.location.reload();
			}).catch(function(err){
				$('#kois-popup-contain #popup-messages-target').html(err);
				// Enable the update button again
				$('#kois-popup-contain #change-payment-method-button').prop( 'disabled', false ).removeClass( 'loading' );
			});
		}

		// Gather required data
		var mp = $.magnificPopup.instance;
		var enrollments = mp.popupData.enrollments || '';
		var card = $('#kois-popup-contain input[name="SelectedCard"]:checked').val() || null;
		if( card !== 'new' ){

			// Attempt to update these enrollments with the specified existing card id
			handleUpdateCard(enrollments, card, null);
		}
		else{
			// Gather new card data and create promise for tokenization process
			var cardNumber = $('#kois-popup-contain input[name="card"]').val() || '';
			var exp = $('#kois-popup-contain input[name="expiration"]').val() || '00/0000';
			var expParts = exp.split('/');
			var storeCardHandler = storeStripeCard({
				number: cardNumber.replace(/\s/g, ''),
				name: mp.popupData.fullname || '',
				expMonth: expParts.length === 2 ? expParts[0] : '00',
				expYear: expParts.length === 2 ? expParts[1] : '0000',
				cvc: $('#kois-popup-contain input[name="cvc"]').val() || null
			});
	
			// When tokenization promise resolves/rejects
			storeCardHandler.then(function(card){
				// Attempt to update these enrollments with the specified token id (which will be stored against the user first)
				handleUpdateCard(enrollments, card.id, card);
			}).catch(function(err){
				// Display an error
				displayPopupError(err);
				// Enable the update button again
				$('#kois-popup-contain #change-payment-method-button').prop( 'disabled', false ).removeClass( 'loading' );
			});
		}
	}

	function storeStripeCard(cardData){
		return new RSVP.Promise(function( resolve, reject ){

			// Basic validation
			if(
				cardData.number.length < 13 || cardData.number.length > 19 ||
				cardData.expMonth.length < 1 || cardData.expMonth.length > 2 ||
				cardData.expYear.length < 2 || cardData.expYear.length > 4 ||
				cardData.cvc.length < 3 || cardData.cvc.length > 4
			){
				reject( 'A valid card number, expiration month/year, and security code are required' );
			}

			$.ajax({
				method: 'POST',
				url: urls.ajax,
				data: {
					action: 'store_stripe_card',
					cardData: cardData
				}
			})
			.done(function( response ) {

				if(response.data.value){
					resolve( response.data.value );
				}
				else{

					if(response.data.message) {
						reject( response.data.message );
					} else {
						reject( 'An error occurred while attempting to store your card' );
					}
				}
			})
			.fail(function(jqXHR, textStatus, errorThrown){
				var errorMessage = 'An error occurred while attempting to store your card';
				var errorMessageAdditional = '';
				if(jqXHR.responseJSON && jqXHR.responseJSON.errors){
					errorMessageAdditional = jqXHR.responseJSON.errors.reduce(function(acc, curr, index){
						var prefix = index !== 0 ? ', ' : '';
						return acc += prefix + (curr.moreInfo ? curr.moreInfo : curr.message);
					}, '');
				}

				if(errorMessageAdditional){
					errorMessage += ': ' + errorMessageAdditional;
				}

				reject( errorMessage );
			});
		});
	}

	/**
	 * Attempts to tokenize the given credit card data using the QB Payments API tokenize endpoint.
	 * 
	 * @param Object cardData An object containing the following properties:
	 * 	number (the card number)
	 * 	name (the name on the card)
	 * 	expMonth (the month this card expires in MM format)
	 * 	expYear (the year this card expires in YYYY format)
	 * 	cvc (the cvc/security code for this card)
	 * 	OPTIONAL: address (object containing streetAddress, city, region, country, and postalCode properties)
	 * @see https://developer.intuit.com/docs/api/payments/tokens
	 * @returns Promise
	 */
	// TODO: Might want to break out the tokenization functionality into a separate JS class for future reuse
	function tokenizeCard(cardData){
		// TODO: Currently depending on the payment gateway API URL, might want to decouple that
		var tokenizeURL = window.wc_intuit_payments_params.api_url || null;
		return new RSVP.Promise(function( resolve, reject ){
			if( tokenizeURL === null ){
				reject( 'Unable to find tokenization API URL' );
			}

			// Basic validation, thanks to the WC payment jQuery extension
			if(
				!$.payment.validateCardNumber( cardData.number ) || 
				!$.payment.validateCardExpiry( cardData.expMonth, cardData.expYear ) || 
				!$.payment.validateCardCVC( cardData.cvc )
			){
				reject( 'A valid card number, expiration month/year, and security code are required' );
			}

			$.ajax({
				method: 'POST',
				url: tokenizeURL,
				contentType: 'application/json',
				data: JSON.stringify({card: cardData})
			})
			.done(function( response ) {
				if(response.value){
					resolve( response.value );
				}
				else{
					reject( 'An error occurred while attempting to tokenize your card' );
				}
			})
			.fail(function(jqXHR, textStatus, errorThrown){
				var errorMessage = 'An error occurred while attempting to tokenize your card';
				var errorMessageAdditional = '';
				if(jqXHR.responseJSON && jqXHR.responseJSON.errors){
					errorMessageAdditional = jqXHR.responseJSON.errors.reduce(function(acc, curr, index){
						var prefix = index !== 0 ? ', ' : '';
						return acc += prefix + (curr.moreInfo ? curr.moreInfo : curr.message);
					}, '');
				}

				if(errorMessageAdditional){
					errorMessage += ': ' + errorMessageAdditional;
				}
				reject( errorMessage );
			});
		});
	}

	function updatePlanCard(enrollments, cardId, card){
		return new RSVP.Promise(function( resolve, reject ){
			$.ajax({
				method: 'POST',
				url: urls.ajax,
				data: {
					action: 'update_card_for_payment_plans',
					enrollments: enrollments,
					cardId: cardId,
					card: card
				}
			})
			.done(function( response ) {
				if(response.success){
					resolve( true );
				}
				else{
					var message = (response.message ? response.message : '<p class="kois-error-text">An error occurred while attempting to update your future payment method.</p>');
					reject( message );
				}
			})
			.fail(function(jqXHR, textStatus, errorThrown){
				var message = '<p class="kois-error-text">An error occurred while attempting to update your future payment method.</p>';
				reject( message );
			});
		});
	}

	function displayPopupError(text){
		$.ajax({
			method: "POST",
			url: urls.ajax,
			data: { action: 'symp_validation_error', title: 'Error', text: text }
		})
		.done(function( res ) {
			if(res && res.success){
				$('#kois-popup-contain #popup-messages-target').html(res.data.message);
			}
			else{
				$('#kois-popup-contain #popup-messages-target').html('<p class="kois-error-text">'+text+'</p>');
			}
		});
	}

	initPopups();

	// Init popup for Payment options when event triggered
	$('body').on('initPopups', initPopups);
	// Reinitialize after content is overwritten by WooCommerce
	$( document ).on( 'updated_wc_div', function(){
		$('body').trigger('initPopups', ['.woocommerce-cart-form']);
	} );

})(jQuery);
